import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)/projects/$projectVersionId/re-inspections')({
    component: Layout,
});

function Layout() {
    return <Outlet />;
}
